import { CSSProperties } from "react";
import classes from "classnames";
import styles from "./index.module.scss";
export type CardFilterItem = {
  label: string;
  value: string;
};

export interface CardFilterProps {
  className?: string;
  style?: CSSProperties;
  title: string;
  items: CardFilterItem[];
  values?: string[];
  itemWidth?: number;
  justifyContent?: "space-between" | "start";
  itemClassName?: string;
  onChange?: (values: string[]) => void;
  multiple?: boolean;
}
const CardFilter = ({
  className,
  style,
  title,
  items,
  itemWidth,
  values = [],
  justifyContent = "space-between",
  itemClassName,
  onChange,
  multiple,
}: CardFilterProps) => {
  const handleItemClick = (item: CardFilterItem) => {
    if (values.includes(item.value)) {
      onChange?.(values.filter((v) => v !== item.value));
      return;
    }
    if (multiple) {
      onChange?.(values?.concat(item.value));
    } else {
      onChange?.([item.value]);
    }
    // onChange?.(item.value);
  };
  return (
    <div className={classes(styles.card, className)} style={style}>
      <div className={styles.title}>{title}</div>
      <div className={styles.body} style={{ justifyContent }}>
        {items.map((item) => (
          <div
            className={classes(
              styles.item,
              values.includes(item.value) && styles.selected,
              itemClassName
            )}
            key={item.value}
            style={{ width: itemWidth }}
            onClick={() => handleItemClick(item)}
          >
            {item.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardFilter;
